import { createContainer } from 'unstated-next';
import { useState } from 'react';
import { survey } from '../constants';

const initialState = {
  [survey.ADD_SERVICE]: {
    isLoading: false,
    upvotes: {},
    businessUpvotes: [],
    isPopulated: false,
  },
};

const useUpvoteContainer = stateParams => {
  const combinedState = {
    ...initialState,
    ...stateParams,
  };
  const [state, updateState] = useState(combinedState);

  const setLoading = surveyName => {
    updateState(prev => ({
      ...prev,
      [surveyName]: {
        ...prev[surveyName],
        isLoading: true,
      },
    }));
  };

  const setUpvotes = (surveyName, { upvotes, businessUpvotes }) => {
    updateState(prev => ({
      ...prev,
      [surveyName]: {
        ...prev[surveyName],
        upvotes,
        businessUpvotes,
        isPopulated: true,
        isLoading: false,
      },
    }));
  };

  const updateUpvotes = (surveyName, upvote) => {
    updateState(prev => {
      const { choice } = upvote;
      const oldSurvey = prev[surveyName];
      const oldVotes = oldSurvey.upvotes;
      const newUpvotes = { ...oldVotes, [choice]: oldVotes[choice] + 1 };
      const oldBusinessVotes = oldSurvey.businessUpvotes;
      const newBusinessVotes = [...oldBusinessVotes, upvote];

      return {
        ...prev,
        [surveyName]: {
          ...prev[surveyName],
          upvotes: newUpvotes,
          businessUpvotes: newBusinessVotes,
          isLoading: false,
        },
      };
    });
  };

  const deleteUpvote = (surveyName, upvote) => {
    updateState(prev => {
      const { choice } = upvote;
      const oldSurvey = prev[surveyName];
      const oldVotes = oldSurvey.upvotes;
      const newUpvotes = { ...oldVotes, [choice]: oldVotes[choice] - 1 };
      const oldBusinessVotes = oldSurvey.businessUpvotes;
      const newBusinessVotes = oldBusinessVotes.filter(
        ({ id }) => id !== upvote.id
      );

      return {
        ...prev,
        [surveyName]: {
          ...prev[surveyName],
          upvotes: newUpvotes,
          businessUpvotes: newBusinessVotes,
          isLoading: false,
        },
      };
    });
  };

  return {
    state,
    setLoading,
    setUpvotes,
    updateUpvotes,
    deleteUpvote,
  };
};

const UpvoteContainer = createContainer(useUpvoteContainer);

export default UpvoteContainer;
